import React from 'react';
import {
  ImageBackground, Pressable, StyleSheet, Text, View,
} from 'react-native';
import PropTypes from 'prop-types';
import APMStyles from '../styles';

function WorkoutCard(props) {
  const {
    backgroundImg, title, description, onPress, time,
  } = props;

  function getTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    // const remainingSeconds = seconds - minutes * 60;
    // return `${minutes.toString().padStart(2, 0)}:${remainingSeconds.toString().padStart(2, 0)}`;
    return `${minutes.toString()} MINUTES`;
  }

  return (
    <Pressable
      style={styles.container}
      onPress={onPress}
    >
      <ImageBackground source={backgroundImg} style={styles.backgroundImage}>
        <View style={styles.backgroundOverlay}>
          <View style={styles.titleContainer}>
            <div>
              <Text style={styles.title}>{title.toUpperCase()}</Text>
              <Text style={styles.subtitle}>{description.toUpperCase()}</Text>
            </div>
            <div>
              <Text style={styles.subtitle}>{getTime(time)}</Text>
            </div>
          </View>
        </View>
      </ImageBackground>
    </Pressable>
  );
}

WorkoutCard.defaultProps = {
  backgroundImg: undefined,
  title: '',
  description: '',
  time: 0,
  onPress: () => {},
};

WorkoutCard.propTypes = {
  backgroundImg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  description: PropTypes.string,
  time: PropTypes.number,
  onPress: PropTypes.func,
};

const styles = StyleSheet.create({
  container: {
    padding: 10,
    width: '100%',
  },
  backgroundImage: {
    borderRadius: 10,
    overflow: 'hidden',
    height: 155,
  },
  backgroundOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
  },
  titleContainer: {
    padding: 10,
    flex: 1,
    justifyContent: 'space-between',
  },
  title: {
    fontSize: APMStyles.typography.title,
    color: APMStyles.colors.text,
    paddingBottom: 10,
  },
  subtitle: {
    fontSize: APMStyles.typography.paragraph,
    color: APMStyles.colors.text,
    display: 'block',
  },
});

export default WorkoutCard;
